import { apacBorderRadius, standardBorderRadius, currentAdProduct, currentAdProductAddOn, unselectedFeatured, unselected, selectedFeatured, selected, selectedBackgroundFeatured, selectedBackground } from "../GridLayout.css.mjs";
const getPanelStyle = ({
  panel,
  isSelected,
  isCurrentProduct,
  theme,
  productType
}) => [
  getBorderRadius(theme),
  getSelectedStyle({
    panel,
    isSelected,
    isCurrentProduct,
    productType
  }),
  getBackgroundStyle(panel, isSelected && !isCurrentProduct, theme)
].join(" ");
const getSelectedStyle = ({
  panel,
  isSelected,
  isCurrentProduct,
  productType
}) => {
  if (isCurrentProduct) {
    switch (productType) {
      case "AdProduct":
        return currentAdProduct;
      case "AdProductAddOn":
        return currentAdProductAddOn;
      default:
        return currentAdProduct;
    }
  }
  if (!isSelected) {
    return (panel == null ? void 0 : panel.variant) === "featured-focus" ? unselectedFeatured : unselected;
  }
  if ((panel == null ? void 0 : panel.variant) === "featured" || (panel == null ? void 0 : panel.variant) === "featured-focus") {
    return selectedFeatured;
  }
  return selected;
};
const getBackgroundStyle = (panel, isSelected, theme) => {
  if (theme !== "apac" || !isSelected) {
    return "";
  }
  if ((panel == null ? void 0 : panel.variant) === "featured" || (panel == null ? void 0 : panel.variant) === "featured-focus") {
    return selectedBackgroundFeatured;
  }
  return selectedBackground;
};
const getBorderRadius = (theme) => theme === "apac" ? apacBorderRadius : standardBorderRadius;
export {
  getPanelStyle
};
